import {SxProps, Theme} from '@mui/material';
import {phoneCardSx} from 'src/components/mobile/mobileDesign.sx';

/**
 * The card a table row becomes below a desktop.
 *
 * It used to be a white block separated from the next one by a hairline, which read as a table that
 * had lost its columns. It is a card now - its own radius, its own shadow, its own edge - because
 * that is what tells someone scrolling where one record ends and the next begins.
 *
 * It is the surface and nothing more: the radius, the border, the shadow. The parts drawn inside it
 * - the head, the pills row, the facts strip - each bring their own padding from the phone design
 * kit, which is why the card adds none of its own.
 */
export const cardSx: SxProps<Theme> = {
    ...(phoneCardSx as object),
    position: 'relative',
};
